/**
 * Danh tiếng động (master-plan 3.3, GDD 5.3).
 *
 * - Mỗi giờ game: tiến về danh tiếng ổn định của chính sách hiện tại
 *   với tốc độ M02 (hồi phục theo cấp số nhân).
 * - Mỗi lượt khách gặp hết hàng: −M03.
 * - Luôn kẹp trong [P24, P25] = [0,8, 1,2].
 */
import { layThamSo, layThamSoMoPhong } from './du-lieu.js';
import { danhTiengOnDinh } from './gia.js';
import type { DuLieuGame, TrangThaiGame } from './types.js';

/** Cập nhật danh tiếng sau 1 giờ game. */
export function capNhatDanhTieng(
  state: TrangThaiGame,
  duLieu: DuLieuGame,
  soLuotHetHang: number,
): void {
  const mucTieu = danhTiengOnDinh(state.chinhSach, duLieu);
  const tocDo = layThamSoMoPhong(duLieu, 'M02');
  state.danhTieng += (mucTieu - state.danhTieng) * tocDo;
  if (soLuotHetHang > 0) {
    state.danhTieng -= soLuotHetHang * layThamSoMoPhong(duLieu, 'M03');
  }
  const thap = layThamSo(duLieu, 'P24');
  const cao = layThamSo(duLieu, 'P25');
  state.danhTieng = Math.min(cao, Math.max(thap, state.danhTieng));
}
